export default {
      id: "income-replacement-usage",
      viewBox: "0 0 100 101",
      url: __webpack_public_path__ + "sprite.svg#income-replacement",
      toString: function () {
        return this.url;
      }
    }